import { femaleQuestionMedium, maleQuestionMedium, bulbMedium } from '@/assets/icons';
import {
  ALWAYS_DO_WHAT_ALWAYS_DID,
  ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE,
  FIND_FAULT,
  FIND_FAULT_SOURCE,
} from './quotes';

const NO_BLAME = `
<div class="ia-sensei-quote">
  <span class="quote">"${FIND_FAULT}"</span>
  <br>
  <span class="author">${FIND_FAULT_SOURCE}</span>
</div>
<h2 class="basic-sub-title">
  Focus on process, not people
</h2>
<p>
  It's human, people want to know who did it wrong. But this is the source of a damaged relationship between manager and workers.<br>
  Human beings avoid being humiliated because it's one of its greatest fears;
  so if someone knows that he is gonna be blamed for doing something wrong (or even not doing it the best way),
  he's gonna hide it and that's normal.
</p>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${femaleQuestionMedium}"></path></svg>
  <span class="question">Well if I don't point out if he did it wrong, he's never gonna improve...</span>
</div>
<p>
  And that's your mistake.
</p>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  <div class="example-title">Let's take the following example :</div>
  Michael did a rookie mistake while manipulating the trolley :
  Of course, everybody knows that on 'lane R', they're supposed to roll the trolleys in reverse.
  Otherwise, they might get stuck at the end of the lane because back wheels can't rotate.<br>
  So now, Michael who forgot about that, is stuck in a very akward position as he can't go back and
  he needs his coworkers' help to empty his trolley and carry it out of the lane...
</div>
<br>
<p>
  Of course, telling Michael what he did wrong will help him understand how to do it right.<br>
  But let's stop focusing on who did the mistake and start focusing on <strong>what went wrong</strong> :
</p>
<br>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  A new coworker did a mistake as there was no indication of the proper way to roll a trolley down the lane.
</div>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${maleQuestionMedium}"></path></svg>
  <span class="question">It shouldn't be too hard to fix this issue, why not add a sign at the entrance of the lane ?</span>
</div>
<p>
  Exactly. And it won't even require anyone to go find Michael to tell him how bad he messed up.<br>
  On the contrary, Michael could be responsible for solving the issue.
  Now, instead of feeling guilty, he will understand that people care bout him and
  he will carry out an improvement for all his coworkers.<br>
  As a conclusion, learn to see <strong>what went wrong</strong> and stop looking for <strong>who did it wrong</strong>.
</p>
<h2 class="basic-sub-title">
  Promote desired behaviour and model the way
</h2>
<p>
  A 'blame free' environment isn't easy to set up and that's more of a cultural challenge than anything else.
  But you can't expect others to make the first move. Start looking at processes instead of people,
  provide suggestions out loud, be honest, and point out people who do it like you.<br>
  If you feel that this kind of environment requires a cultural change, you can only
  achieve it by encouraging and supporting each other, and showing how one can take responsibility.
</p>
<div class="ia-sensei-quote">
  <span class="quote">"${ALWAYS_DO_WHAT_ALWAYS_DID}"</span>
  <br>
  <span class="author">${ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE}</span>
</div>
<p>
  Now, this is easier said than done. That's why managers and team leaders must set up the proper conditions
  for people to express themselves. Let everyone have a moment to speak his mind every week; while doing field tours,
  ask coworkers how they feel; when solving problems, ask people how they want to be a part of it.<br>
  In short, provide an environment in which colleagues trust and support each other.
  That's the road to a 'blame free' environment.
</p>
`;

const NO_BLAME_TITLE = 'Don\'t blame';

export default {
  NO_BLAME,
  NO_BLAME_TITLE,
};
